import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class MetaDataService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiDataURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  getCategories = () => {
    const request = {
      method: 'GET',
      url: '/categories',
      params: {},
    };
    return this.axios(request);
  };

  getCategoriesWithItems = () => {
    const request = {
      method: 'GET',
      url: '/categories-with-items',
      params: {},
    };
    return this.axios(request);
  };
}

export default new MetaDataService();
